export default __webpack_public_path__ + "static/media/AshleeNew.6508e282.jpeg";